import { makeStyles } from '@material-ui/styles';

export default makeStyles(
    {
        group: {
            display: 'flex',
            alignItems: 'stretch',
            width: '100%',
            marginBottom: '10px',
            maxWidth: '600px',
            "@media (max-width: 600px)": {
                display: 'contents',
            }
        },
        toogleButton: {
            width: '20vw',
            height: '5vh',
            borderRadius: '30px',

        },
    },
);
